export default "__VITE_ASSET__Drr0XvSO__"